import React, { Component } from 'react';
import { Text, Box } from '@acast/decibel';
import UploadableImage from 'shared/components/uploadable-image';
import { Episode } from 'client/resources';
import { resolve } from 'acast-www-utils';
import updateEntity from 'app/entity/actions/update';
import { getImage } from 'services/image-api';
import { DEFAULT_COVER_IMAGE } from 'resources/show/schema';
import resourceProp from 'shared/helpers/resource-prop';
import FixedRatioColoredBackground from '../fixed-ratio-colored-background';

export default class CoverImage extends Component {
  static contextTypes = {
    episode: resourceProp(Episode),
  };

  onImage = url => {
    const { episode } = this.context;
    updateEntity(
      Episode,
      episode.data.merge({
        image: url,
      })
    );
  };

  render() {
    const { episode } = this.context;
    const id = resolve(episode, 'data.id', '');
    const { inProgress } = episode;
    let src = resolve(episode, 'data.image', null);
    if (src === null) {
      src = DEFAULT_COVER_IMAGE;
    } else {
      src = getImage(src, { w: 400 });
    }

    return (
      <>
        <FixedRatioColoredBackground>
          <div className="episode-cover-image">
            <div className="episode-cover-image__body">
              <UploadableImage
                entity={id}
                name="cover-image"
                enabled={!inProgress}
                src={src}
                onImageUploaded={this.onImage}
                onImageRemoved={() => this.onImage(null)}
                enableRemove={src !== DEFAULT_COVER_IMAGE}
              />
            </div>
          </div>
        </FixedRatioColoredBackground>
        <Box>
          <Text variant="caption" mt={1}>
            Min. size 1400x1400 px – Max size 3000x3000 px in .png or .jpg
          </Text>
        </Box>
      </>
    );
  }
}
